import oRequest from '@/libsV2/request.js';

const URL = {
    DATAVIEW_USER_INFO: 'dataview/index/userinfo',          //用户信息
    ARCHIVES_INFO: "archives/index/index",                  //账户信息
    LOG_INFO: "archives/dossier/log",                       //日志信息
    CONTRACT_LIST: "archives/dossier/contract",             //合同列表
    CONTRACT_INFO: "archives/contract/index",               //合同详情
    CHANGE_INFO: "archives/contract/change",                //合同变更详情
    APPROVALLOG_INFO: "archives/contract/approvallog",      //审批流程
    RECORD_INFO: "archives/contract/record",                //变更记录
    FOLLOW_INFO: 'archives/dossier/follow',                 //跟进记录
    LOG_BELL: 'report/log/bell',                            //小铃铛日志记录
};

export const getDataviewUserInfo = (data = {}) => {
    return oRequest.getData(URL.DATAVIEW_USER_INFO, data);
};

export const getArchivesInfo = (data = {}) => {
    return oRequest.getData(URL.ARCHIVES_INFO, data);
};

export const getLogInfo = (data = {}) => {
    return oRequest.getData(URL.LOG_INFO, data);
};

export const getContractList = (data = {}) => {
    return oRequest.getData(URL.CONTRACT_LIST, data);
};

export const getContractInfo = (data = {}) => {
    return oRequest.getData(URL.CONTRACT_INFO, data);
};

export const getChangeInfo = (data = {}) => {
    return oRequest.getData(URL.CHANGE_INFO, data);
};

export const getApprovallogInfo = (data = {}) => {
    return oRequest.getData(URL.APPROVALLOG_INFO, data);
};

export const getRecordInfo = (data = {}) => {
    return oRequest.getData(URL.RECORD_INFO, data);
};

export const getFollowInfo = (data = {}) => {
    return oRequest.getData(URL.FOLLOW_INFO, data);
};

export const getLogBell = (data = {}) => {
    return oRequest.getData(URL.LOG_BELL, data);
};


